import { parseServerMessage } from "@uzverse/core";
import type { ClientMessage, RealtimeConnection, ServerMessage } from "@uzverse/core";

/** WebSocket transport for the gateway's realtime protocol. */
export function createWebSocketConnection(url: string): RealtimeConnection {
  const listeners = new Set<(m: ServerMessage) => void>();
  const queue: string[] = [];
  const socket = new WebSocket(url);

  socket.addEventListener("open", () => {
    for (const payload of queue.splice(0)) socket.send(payload);
  });
  socket.addEventListener("message", (event: MessageEvent<unknown>) => {
    if (typeof event.data !== "string") return;
    let message: ServerMessage;
    try {
      message = parseServerMessage(JSON.parse(event.data));
    } catch {
      return; // Ignore frames that do not match the protocol.
    }
    for (const listener of listeners) listener(message);
  });
  socket.addEventListener("close", () => {
    // Surface the drop so the client can reconnect and resume from its last seq.
    for (const listener of listeners) {
      listener({ type: "error", code: "unavailable", message: "connection closed", seq: 0 });
    }
  });

  return {
    send(message: ClientMessage) {
      const payload = JSON.stringify(message);
      if (socket.readyState === WebSocket.OPEN) socket.send(payload);
      else if (socket.readyState === WebSocket.CONNECTING) queue.push(payload);
    },
    onMessage(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    close() {
      socket.close();
    },
  };
}
